


























































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UserStore from '@/stores/user/user.store';
import KeycloakStore from '@/stores/user/keycloak.store';
import Routes from '@/util/Routes';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import StyledSelect, { StyledSelectData } from '@/views/common/StyledSelect.vue';
import { ErrorStore } from '@/stores/error.store';
import { Urls } from '@/util/Urls';
import { EventKey } from '@/util/EventKey';
import { CmsStore } from '@/stores/cms.store';
import { LinkDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import { Config } from '@/util/Config';

@Component({
  components: {CmsLink, StyledSelect, LoadingIndicator},
})
export default class HeaderTopBar extends Vue {
  private cmsStore = getModule(CmsStore, this.$store);
  private userStore = getModule(UserStore, this.$store);
  private errorStore = getModule(ErrorStore, this.$store);
  private keycloakStore = getModule(KeycloakStore, this.$store);
  private routes = Routes;
  private open: boolean = false;

  public get hasLanguageOptions(): boolean {
    return this.languages.length > 1;
  }

  // NOTE: This logic is duplicated in MobileHeaderMenu.vue
  public get languages(): Array<StyledSelectData<string>> {
    const languages = Config.LANGUAGES.map(({code, name}: {code: string, name: string}) => {
      return {displayString: name, key: code, value: code};
    });
    if (!languages.some((item: StyledSelectData<string>) => item.key === this.currentLanguage)) {
      languages.push({displayString: this.currentLanguage, key: this.currentLanguage, value: this.currentLanguage});
    }
    return languages;
  }

  public get topLinks(): LinkDto[] {
    return this.cmsStore.header?.topLinks ?? [];
  }

  public get logoUrl(): string {
    return Urls.logoPath();
  }

  public get email(): string | null {
    if (this.userStore.currentUser) {
      return this.userStore.currentUser.email;
    } else if (this.keycloakStore.profile) {
      return this.keycloakStore.profile.email || null;
    } else {
      return null;
    }
  }

  public get currentSelectedLanguage(): StyledSelectData<string> | null {
    return this.languages.find((lang) => lang.value === this.currentLanguage) ?? null;
  }

  public async mounted() {
    await this.keycloakStore.initialize();
    if (this.keycloakStore.authenticated && this.$router.currentRoute.name !== this.routes.Register) {
      const user = await this.userStore.fetchUserOnce();
      if (!user.success) {
        if (this.$router.currentRoute.name === this.routes.Register) {
          this.errorStore.dismissResponseError(user);
        }
      }
    }
  }

  public async login() {
    await this.keycloakStore.login();
  }

  public logout() {
    this.keycloakStore.logout();
  }

  get authenticated() {
    return this.keycloakStore.authenticated;
  }

  get currentLanguage(): string {
    return this.userStore.currentLanguage;
  }

  get duringPayment() {
    return this.$route.path === '/payment-transaction';
  }

  get duringCheckout() {
    return this.$route.path.startsWith('/checkout');
  }

  get duringRegistration() {
    return this.$route.matched.some((record) => record.meta.isRegisterHeader);
  }

  public async changeLanguage(newLanguageName: string, newLangKey: string) {
    if (this.keycloakStore.authenticated) {
      await this.userStore.changeUserLanguage(newLangKey);
    } else {
      this.userStore.setLocalLanguage(newLangKey);
    }
    this.$events.$emit(EventKey.LANGUAGE_CHANGE, newLangKey);
  }

  public openDialog() {
    this.open = true;
  }

  public closeDialog() {
    this.open = false;
  }
}
